import {NgModule} from '@angular/core';
import {RpConfigPage} from "./page/overview/config/rp-config.page";
import {RpReportObjectComponent} from "./component/protected-components/rp-report/rp-report-object.component";
import {BlockUIModule} from 'primeng/blockui';
import {ProgressSpinnerModule} from "primeng/progressspinner";
import {RpReportComponent} from "./component/protected-components/rp-report-component/rp-report.component";
import {RpReportPage} from "./page/report-page/rp-report.page";
import {AmModule} from "../../feature-core/am/am.module";
import {
    RpReportAgentFavoriteComponent
} from "./component/protected-components/rp-report-agent-favorite/rp-report-agent-favorite.component";
import {
    RpLogicReportObjectComponent
} from "./component/protected-components/rp-logic-report/rp-logic-report-object.component";
import {RpLogicReportObjectPage} from "./page/object/rp-logic-report-object-page/rp-logic-report-object.page";
import {RpLogicReportLaunchpadPage} from "./page/logic-report-launchpad/rp-logic-report-launchpad.page";
import {RP_ENTITY_PROVIDER} from "./rp.entity-provider";
import {CoreModule} from "../../core/core.module";
import {IconField} from "primeng/iconfield";
import {InputIcon} from "primeng/inputicon";
import {RP_TEST_PROVIDERS} from "./test/rp-test-definition";
import {DynamicModule} from "../../core/shared/interface/dynamic-module.interface";
import {ModuleRegistryService} from "../../core/shared/interface/module-registration.service";


@NgModule({
  declarations: [
    RpConfigPage,
    RpReportObjectComponent,
    RpReportComponent,
    RpReportPage,
    RpReportAgentFavoriteComponent,
    RpLogicReportObjectComponent,
    RpLogicReportObjectPage,
    RpLogicReportLaunchpadPage
  ],
  exports:[
    RpConfigPage,
    RpReportObjectComponent,
    RpReportComponent,
    RpReportPage,
    RpReportAgentFavoriteComponent,
    RpLogicReportObjectComponent,
    RpLogicReportObjectPage,
    RpLogicReportLaunchpadPage
  ],
    imports: [
        CoreModule,
        BlockUIModule,
        ProgressSpinnerModule,
        AmModule,
        IconField,
        InputIcon
    ],
  providers: [RP_ENTITY_PROVIDER, RP_TEST_PROVIDERS]
})
export class RpModule implements DynamicModule {

    alias = 'rp';

    constructor(private moduleRegistry: ModuleRegistryService) {
        this.moduleRegistry.registerModule(this);
    }

    getKpiComponent() {
        return null;
    }

    getStatisticsComponent() {
        return null;
    }
}